<script setup>
import SettingsButton from "@/components/citations/partials/SettingsButton.vue";
import CustomMultiselect from "@/components/global-themed/CustomMultiselect.vue";
import {computed, watch} from "vue";
import {getGBPLocations} from "@/composables/useGBPLocations";
import {selectedLocation} from "@/composables/citations/useCitations";

const {data} = getGBPLocations();

const locationOptions = computed(() => {
  if (!data.value || data.value.length === 0) {
    return [];
  }

  return data.value.map(({ id, title, short_address }) => ({
    value: id,
    label: `${title} ${short_address ? `(${short_address})` : ''}`,
  }));
})

watch(selectedLocation, (newLocationId) => {
  if (!newLocationId) {
    return;
  }
  const currentPath = window.location.pathname;
  const pathParts = currentPath.split('/');

  const citationsIndex = pathParts.findIndex(part => part === 'citations');
  if (citationsIndex === -1 || !pathParts[citationsIndex + 1]) {
    return;
  }

  pathParts[citationsIndex + 1] = newLocationId.toString();
  const newPath = pathParts.join('/');

  window.history.pushState({}, '', newPath);
});

</script>

<template>
  <div class="tw-flex tw-justify-between">
    <div class="tw-flex tw-flex-col tw-w-full tw-gap-3">
      <label
        for="location"
        class="tw-self-start tw-text-lg tw-leading-none tw-text-neutral-900 tw-font-bold tw-l"
      >
        Locations
      </label>
      <div class="tw-flex tw-gap-4">
        <CustomMultiselect
          id="location"
          v-model="selectedLocation"
          class="tw-text-left tw-w-[358px] tw-h-12 tw-relative"
          :close-on-select="true"
          :options="locationOptions"
          :searchable="true"
          placeholder="Select Location"
          :min-chars="3"
          :filter-results="false"
          :resolve-on-load="false"
          :delay="0"
          :can-deselect="false"
        >
          <template #icon>
            <svg-vue
              icon="icons/location-pin"
              class="tw-w-6 tw-h-7 tw-text-neutral-500"
            />
          </template>
        </CustomMultiselect>

        <SettingsButton />
      </div>
    </div>
  </div>
</template>
